/* Additive Luvano traffic events for the existing Kriath Meta pixel. */
(function (w, d) {
  "use strict";
  var id = "1583038503477044", guard = "__luvanoMeta1583038503477044";
  if (w[guard]) return;
  w[guard] = true;
  if (!w.fbq) {
    var q = w.fbq = function () { q.callMethod ? q.callMethod.apply(q, arguments) : q.queue.push(arguments); };
    if (!w._fbq) w._fbq = q;
    q.push = q; q.loaded = true; q.version = "2.0"; q.queue = [];
  }
  w.fbq("init", id);
  function track(name, params) { w.fbq("trackSingle", id, name, params || {}); }
  var host = w.location.hostname.toLowerCase();
  var product = host === "luvanobaby.com" ? "8544835731643" : host === "luvanosupps.com" ? "8544835895483" : null;
  if (!product) {
    var path = w.location.pathname;
    if (path === "/products/luvano-tanning-drops") product = "15444890714299";
    else if (path === "/products/luvano-brightening-drops") product = "15444890779835";
    else if (/babyguard|little-explorer/i.test(path)) product = "8544835731643";
    else if (/cinnamon/i.test(path)) product = "8544835895483";
  }
  track("PageView");
  if (product) track("ViewContent", {content_ids:[product],content_type:"product"});
  if (!d.querySelector('script[src*="connect.facebook.net"][src*="fbevents.js"]')) {
    var library = d.createElement("script"); library.async = true; library.src = "https://connect.facebook.net/en_US/fbevents.js";
    d.head.appendChild(library);
  }
  var fetch = w.fetch, state = null, queue = Promise.resolve();
  if (typeof fetch !== "function") return;
  function physical(line) { return line && String(line.product_id || "") === product; }
  function quantities(cart) {
    var result = Object.create(null);
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (line) {
      if (physical(line)) result[String(line.variant_id || line.id)] = Math.max(0, Number(line.quantity) || 0);
    });
    return result;
  }
  function observe(response, path) {
    if (!response || !response.ok || typeof response.clone !== "function") return;
    return response.clone().json().then(function (data) {
      if (path === "/cart/add.js") {
        var items = data && Array.isArray(data.items) ? data.items : [data];
        if (items.some(physical)) track("AddToCart", {content_ids:[product],content_type:"product"});
        state = null;
      } else {
        var next = quantities(data), added = false;
        if (state) Object.keys(next).forEach(function (key) { if (next[key] > (state[key] || 0)) added = true; });
        state = next;
        if (added) track("AddToCart", {content_ids:[product],content_type:"product"});
      }
    }).catch(function () {});
  }
  var baseline = Promise.resolve(fetch.call(w,"/cart.js",{credentials:"same-origin",headers:{Accept:"application/json"}}))
    .then(function (r) { return r && r.ok ? r.json() : null; }).then(function (c) { if (c) state = quantities(c); }).catch(function () {});
  w.fetch = function (input, init) {
    var path = "", method = String(init && init.method || input && input.method || "GET").toUpperCase();
    try { var u = new URL(typeof input === "string" ? input : input && input.url, w.location.href); if (u.origin === w.location.origin) path = u.pathname; } catch (_) {}
    var response = fetch.apply(this, arguments);
    if (method === "POST" && (path === "/cart/add.js" || path === "/cart/update.js")) {
      var observed = Promise.resolve(response).then(function (r) { return r && r.ok && typeof r.clone === "function" ? r.clone() : null; }).catch(function () { return null; });
      queue = queue.then(function () { return baseline; }).then(function () { return observed; }).then(function (r) { return observe(r,path); }).catch(function () {});
    }
    return response;
  };
})(window, document);
